// client/src/coms/components/comslayout_parts/useJoinServer.js
import { useCallback, useState } from 'react';
import { pickServerIdFromJoinResponse } from './serverApi';
import { joinByInvite } from '../../e2ee/EncryptionConsentHost';

export default function useJoinServer({ servers, refreshServers, setActiveServerId, setActiveTab, navigate }) {
  const [joinInviteCode, setJoinInviteCode] = useState('');
  const [joinBusy, setJoinBusy] = useState(false);
  const [joinErr, setJoinErr] = useState('');

  const handleJoinServer = useCallback(async () => {
    if (joinBusy) return;

    const code = String(joinInviteCode || '').trim();

    setJoinErr('');
    if (!code) {
      setJoinErr('Enter an invite code');
      return;
    }

    setJoinBusy(true);
    try {
      const res = await joinByInvite({ invite_code: code });
      if (res && res.ok) {
        const sid = pickServerIdFromJoinResponse(res);
        await refreshServers(true);

        setJoinInviteCode('');
        setJoinErr('');

        if (sid) {
          setActiveServerId(String(sid));
          setActiveTab('coms');
          navigate(`/comms/${encodeURIComponent(String(sid))}`);
          return;
        }

        const nextList = Array.isArray(servers) ? servers : [];
        const first = nextList && nextList.length ? String(nextList[0].id) : '';
        if (first) {
          setActiveServerId(first);
          setActiveTab('coms');
          navigate(`/comms/${encodeURIComponent(first)}`);
          return;
        }

        return;
      }

      setJoinErr('Join failed');
    } catch (e) {
      const msg = String((e && e.message) || e || 'Join failed');
      setJoinErr(msg);
    } finally {
      setJoinBusy(false);
    }
  }, [joinBusy, joinInviteCode, refreshServers, servers, setActiveServerId, setActiveTab, navigate]);

  const openJoinOnEnter = useCallback(
    (e) => {
      if (!e) return;
      if (e.key === 'Enter') {
        e.preventDefault();
        handleJoinServer();
      }
    },
    [handleJoinServer]
  );

  return {
    joinInviteCode,
    setJoinInviteCode,
    joinBusy,
    joinErr,
    handleJoinServer,
    openJoinOnEnter,
  };
}